import { createContext } from 'react';

export interface AuthErrorState {
  hasAuthError: boolean;
  isRefreshing: boolean;
  errorMessage: string | null;
}

export interface AuthErrorContextType {
  authErrorState: AuthErrorState;
  setAuthError: (message: string) => void;
  clearAuthError: () => void;
  setRefreshing: (isRefreshing: boolean) => void;
  showTokenExpiredNotification: () => void;
}

export const AuthErrorContext = createContext<AuthErrorContextType | undefined>(
  undefined
);
